import React from 'react';
import ReactDOM from 'react-dom/client';
import VoxelGame from './components/VoxelGame';
import './styles/app.css';

const tg = window.Telegram?.WebApp;
if (tg) {
    try {
        tg.ready();
        tg.expand();
        if (typeof tg.setHeaderColor === 'function') {
            tg.setHeaderColor('#161311');
        }
        if (typeof tg.setBackgroundColor === 'function') {
            tg.setBackgroundColor('#161311');
        }
        // Allow portrait + landscape; fullscreen (requested on puzzle open) reclaims header height.
        if (typeof tg.unlockOrientation === 'function') {
            tg.unlockOrientation();
        }
        import('./config/telegramUi.js').then((m) => m.applyTelegramSafeAreaVars());
    } catch (e) {
        console.warn('[Telegram.WebApp] ready/expand failed', e);
    }
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <VoxelGame />
    </React.StrictMode>
);
